'use client';

import {useEffect} from 'react';
import amplitudeService from '@features/analytics/amplitudeService';
import {EmptyState} from '@features/chat/components/EmptyState';

type Variant = keyof typeof COPY;

type VariantCopy = {
  title: string;
  subtitle: string;
  actionLabel: string;
  eventName: string;
};

const COPY = {
  flow: {
    title: "This project doesn't exist",
    subtitle: 'It may have been deleted, or the link is wrong.',
    actionLabel: 'Back to projects',
    eventName: '[Flow] not found shown',
  },
  preview: {
    title: "This preview isn't available",
    subtitle: 'The project may have been deleted or the share link revoked.',
    actionLabel: 'Go to Banani',
    eventName: '[Preview] not found shown',
  },
  prototype: {
    title: "This prototype isn't available",
    subtitle: 'The project may have been deleted or the link is wrong.',
    actionLabel: 'Go to Banani',
    eventName: '[Prototype] not found shown',
  },
  generic: {
    title: 'Page not found',
    subtitle: 'We could not find the page you requested.',
    actionLabel: 'Go to Banani',
    eventName: '404',
  },
} as const satisfies Record<string, VariantCopy>;

export const FlowNotFoundScreen = ({variant}: {variant: Variant}) => {
  const copy = COPY[variant];

  useEffect(() => {
    amplitudeService.logEvent(copy.eventName, {variant});
  }, [copy.eventName, variant]);

  return (
    <div className='flex min-h-screen w-screen items-center justify-center bg-white'>
      <EmptyState
        title={copy.title}
        subtitle={copy.subtitle}
        action={{label: copy.actionLabel, href: '/'}}
      />
    </div>
  );
};
